import React from 'react'
import logo from '../../assets/logo-bg.png'
import { FaFacebook} from "react-icons/fa";

import './footer.css'

function Footer() {
  return (
    <div className='footer-container '>
    <div className='grey-top-line'></div>
    <div className='row mt-3 '>
      <div className='col div-footer-text d-flex flex-column'>
        <div className='social'>
        <a  href='https://www.facebook.com/gravstengraveringab' target='blank'><FaFacebook size={30} /></a> 
       </div> 
       <div><p className='footer-text'>Gravstens service <br/> inom Västra Götalands län och Halland.</p>
</div>
      </div>
      <div className='col logo-div-footer'>
        <img width='150px' src={logo} alt='logo'/>
      </div>
     
    </div>
    <div className="footer-copyright">
          Copyright &#169; Gravsten Service| 2023
        </div>
        <div className="footer-alina mb-2">
        <a href='https://www.samoteev.dev/' target='blank'>Digital magic created by AS</a>  
        </div>
    </div>
  ) 
}

export default Footer